export default __webpack_public_path__ + "static/media/gift.391619db.png";